import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import { precisaAceiteLegal } from '../../utils/legalAccess';

const carregando = (
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 60 }}>Carregando...</div>
);

// Salva o workspace do titular e recarrega na mesma rota, já no espaço compartilhado.
function EntrarNoWorkspace({ titularId }) {
  useEffect(() => {
    let atual = null;
    try { atual = localStorage.getItem('workspace_titular'); } catch { /* ignore */ }
    if (atual === String(titularId)) return; // já salvo: evita loop de reload
    try { localStorage.setItem('workspace_titular', String(titularId)); } catch { return; }
    window.location.replace(window.location.pathname + window.location.search);
  }, [titularId]);
  return carregando;
}

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, acessoPermitido, user } = useAuth();
  const { emWorkspaceCompartilhado, resolvendoWorkspace } = useWorkspace() || {};
  const location = useLocation();

  if (!isAuthenticated) {
    const dest = location.pathname + location.search;
    return <Navigate to={`/login?redirect=${encodeURIComponent(dest)}`} replace />;
  }

  // Ainda descobrindo se o usuário está num workspace compartilhado: aguarda.
  if (resolvendoWorkspace && !precisaAceiteLegal(user)) {
    return carregando;
  }

  if ((precisaAceiteLegal(user) || sessionStorage.getItem('legal_gate_required') === '1')
      && location.pathname !== '/aceitar-termos') {
    sessionStorage.setItem('legal_redirect_after', location.pathname + location.search);
    return <Navigate to="/aceitar-termos" replace />;
  }

  if (!precisaAceiteLegal(user)) {
    sessionStorage.removeItem('legal_gate_required');
  }

  // Convidado operando o workspace de um titular: o acesso é do titular (o backend
  // valida). Não bloqueia pelo trial/assinatura do próprio convidado.
  if (emWorkspaceCompartilhado) {
    return children;
  }

  if (!acessoPermitido) {
    // Convidado sem acesso próprio: o único espaço dele é o do titular.
    if (user?.workspace_convidado) {
      return <EntrarNoWorkspace titularId={user.workspace_convidado} />;
    }
    // Cadastrou-se por um convite e ainda não aceitou: retoma o aceite.
    if (user?.convite_pendente_token) {
      return <Navigate to={`/convite/${user.convite_pendente_token}`} replace />;
    }
    if (user?.ja_teve_assinatura) {
      return <Navigate to="/checkout" replace />;
    }
    const teveTrial = Boolean(user?.teve_trial);
    return <Navigate to={teveTrial ? '/acesso-bloqueado' : '/checkout'} replace />;
  }

  return children;
};

export default ProtectedRoute;